define.alias("shared/components/shared/referral-promo-banner", "settings/components/shared/referral-promo-banner");